import { render, staticRenderFns } from "./TabelaValidacao.vue?vue&type=template&id=2d855bce"
import script from "./TabelaValidacao.vue?vue&type=script&lang=js"
export * from "./TabelaValidacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports